// removed by extract-text-webpack-plugin
module.exports = {"timer":"timer__14y7h","divider":"divider__1-YwI"};


//////////////////
// WEBPACK FOOTER
// ./components/countdown/styles/CarouselCountdownTimer.scss
// module id = 8OyM
// module chunks = 1